import { styled } from '@uhg-abyss/web/tools/styled';
export const ThingsToConsiderModalStyle = {
  'abyss-modal-base-content-container': {
    width: '784px',
    maxHeight: '90vh',
  },
  'abyss-modal-base-body': {
    overflowY: 'auto',
    maxHeight: 'calc(90vh - 250px)',
  },
};

export const ThingsToConsiderModalStyleEni = {
  'abyss-modal-base-content-container': {
    width: '784px',
    maxHeight: '90vh',
  },
  'abyss-modal-base-body': {
    overflowY: 'auto',
    maxHeight: 'calc(90vh - 250px)',
  },
};

export const ThingsToConsiderMobileModalStyle = {
  'abyss-modal-base-content-container': {
    width: '343px',
    maxHeight: '90vh',
  },
  'abyss-modal-base-body': {
    overflowY: 'auto',
    maxHeight: 'calc(90vh - 280px)',
  },
};

export const ThingsToConsiderMobileModalStyleEni = {
  'abyss-modal-base-content-container': {
    width: '343px',
    maxHeight: '90vh',
  },
  'abyss-modal-base-body': {
    overflowY: 'auto',
    maxHeight: 'calc(90vh - 280px)',
  },
};

export const ModalContent = styled('div', {
  padding: '8px 16px',
  marginTop: '8px',
});

export const MedicalAvatar = styled('div', {
  width: '70px',
  height: '70px',
  borderRadius: '50%',
  margin: '10px auto',
});

export const ModalTitle = styled('h2', {
  textAlign: 'center',
});

export const ModalSubTitle = styled('p', {
  fontSize: '18px',
  fontWeight: '400',
  lineHeight: '24px',
  textAlign: 'center',
  paddingLeft: '0px',
  color: '$core.color.neutral.80',
});

export const ModalHeading = styled('h3', {
  fontSize: '18px',
  fontWeight: '700',
  lineHeight: '24px',
  textAlign: 'left',
  margin: '10px 16px 10px 16px',
  paddingBottom: '0px',
  color: 'var(--abyss-psx-parcel-colors-black) !important',
});

export const ModalDataContent = styled('p', {
  margin: '0 16px',
  fontSize: '18px',
  fontWeight: '400',
  color: '$core.color.neutral.80',
  lineHeight: '24px',
  padding: '0px 0px 24px 0px',
});
